"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useRecommendationSetup = require("../../hooks/recommendation/useRecommendationSetup");
var _useRecommendationStatus = require("../../hooks/recommendation/useRecommendationStatus");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _RecommendationBody = _interopRequireDefault(require("./RecommendationBody"));
var _RecommendationHeaderFactory = _interopRequireDefault(require("./RecommendationHeaderFactory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StyledGridRow = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.GridRow);
var RecommendationBodyWrapper = function RecommendationBodyWrapper() {
  (0, _useRecommendationSetup.useRecommendationSetup)();
  var _useRecommendationSta = (0, _useRecommendationStatus.useRecommendationStatus)(),
    isRecommendationReady = _useRecommendationSta.isRecommendationReady;
  return isRecommendationReady ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginBottom: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_RecommendationHeaderFactory.default, null))), /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_RecommendationBody.default, null))))) : null;
};
var _default = RecommendationBodyWrapper;
exports.default = _default;